import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

// Format date properly, used in several places
function formatDate(date, circa, tasmeo) {
  if (date) {
    const formatted = dayjs(date, 'YYYY-M-D').format('YYYY-M-D') // Remove 0 padding in date components
    const withCirca = `${formatted}${circa ? ' (ca)' : ''}`
    return tasmeo ? `[${withCirca}]` : withCirca
  }
}

export default function documentDate(document) {
  const first = formatDate(document.data_desde, document.data_desde_circa, document.data_desde_tasmeo)
  const last = formatDate(document.data_ata, document.data_ata_circa, document.data_ata_tasmeo)
  if (first && last && first === last) {
    return [first]
  } else if (first && last) {
    return [first, '/', last]
  } else if (first && !last) {
    return [first, '/', null]
  } else if (!first && last) {
    return [null, '/', last]
  } else {
    return []
  }
}
